// Central branding configuration for the main conference website.
//
// The system is a reusable conference-management platform ("COMPASS"). This
// file separates two brand layers so the same codebase can be re-deployed for
// another conference by editing config + swapping assets only:
//
//   • PRODUCT brand  = COMPASS  — the platform. Constant across clients, shown
//                                 subtly ("Powered by COMPASS").
//   • INSTANCE brand = the conference (ICES2026, …) — the primary, prominent
//                                 identity for a given deployment.
//
// Values fall back to the current ICES2026 defaults, but every field can be
// overridden per deployment via CRA env vars (REACT_APP_*) without code changes.

export const brand = {
  // ---- Instance (conference) brand: primary, prominent ----------------------
  conference: {
    name: process.env.REACT_APP_CONFERENCE_NAME || 'ICES2026',
    url: process.env.REACT_APP_CONFERENCE_URL || 'https://ices2026.com',
    contactEmail: process.env.REACT_APP_CONFERENCE_EMAIL || 'ices2026@uq.edu.au',
  },

  // ---- Product brand: the platform powering this deployment (secondary) -----
  product: {
    name: process.env.REACT_APP_PRODUCT_NAME || 'COMPASS',
    tagline:
      process.env.REACT_APP_PRODUCT_TAGLINE ||
      'Conference Organization, Management, Peer-review And Submission System',
    // Public product/marketing site. Leave empty until the COMPASS landing page
    // exists — the attribution then renders as plain text instead of a dead link.
    url: process.env.REACT_APP_PRODUCT_URL || '',
    // Per-tenant white-label switch: set REACT_APP_SHOW_COMPASS=false to hide
    // the "Powered by COMPASS" attribution for a client that opts out.
    showAttribution:
      String(process.env.REACT_APP_SHOW_COMPASS ?? 'true').toLowerCase() !== 'false',
  },
};

export default brand;
